import EmailConnection from "0.Mine/0.Components/Guides/Email";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

function EmailConnectionPage() {
  return (
    <DashboardLayout>
      <EmailConnection />
    </DashboardLayout>
  );
}

export default EmailConnectionPage;
